import React from "react";
import Sidebar from "../Common/component/Sidebar";
import Navbar from "../Common/component/Navbar";
import UploadViewCustomer from "../Common/component/uploadviewcustomer/UploadViewCustomer";

const ViewCustomerUpload = () => {
  return (
    <>
      <section>
        <div
          className="container-fluid"
          style={{
            overflow: "hidden",
            height: "100vh",
            backgroundColor: " rgb(206, 164, 245)",
          }}
        >
          <div className="row p-0">
            <div className="col-lg-2 p-0">
              <Sidebar />
            </div>
            <div className="col-lg-10  p-0">
              <div className="row ">
                <div className="col-lg-12 p-0">
                  <Navbar />
                </div>
                <div className="col-lg-12 ">
                  <UploadViewCustomer />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ViewCustomerUpload;
